import { render } from "./AppItems.vue?vue&type=template&id=0ca640d6"
import script from "./AppItems.vue?vue&type=script&lang=js"
export * from "./AppItems.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\lotus-Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__